// The PHP services answer a refused write with HTTP 200 and a Result body:
// { status: false, error: { code, data } }. axios does not reject on that, so a bare `catch` reads
// a refusal as success — every component in this app has been showing "Saved" for writes that
// never happened. Pass a response through here before treating it as saved.

const MAX_LISTED_VALUES = 5;

const list = (values) => {
  const shown = values.slice(0, MAX_LISTED_VALUES).join(', ');
  if (values.length <= MAX_LISTED_VALUES) {
    return shown;
  }

  return `${shown} and ${values.length - MAX_LISTED_VALUES} more`;
};

// Codes worth spelling out for an editor. Anything else falls back to the code itself, which is at
// least searchable — better than a generic failure.
const messages = {
  // texts-sv and service-clinics own different stores and report the same problem under their
  // own codes; the message is identical because the fix an editor has to make is identical.
  'texts.text.invalid_reference': (data) => {
    const values = (data.references || []).map((r) => `"${r.value}"`);

    return `These links are not addresses: ${list(values)}. A link must start with http://, https:// or /.`;
  },
  'clinics.text.invalid_reference': (data) => {
    const values = (data.references || []).map((r) => `"${r.value}"`);

    return `These links are not addresses: ${list(values)}. A link must start with http://, https:// or /.`;
  },
  'cms-api.upsert_doc.alias_taken': (data) =>
    `Slug "${data.alias}" already belongs to page #${data.doc_id}.`,
  'cms-api.upsert_doc.missing_fields': (data) =>
    `Missing required fields: ${(data.fields || []).join(', ')}.`,
  'users.employee.access_denied': () =>
    'Only the admin department or a supervisor can change employees.',
  'users.employee.no_user': () =>
    'This employee has no account in the users service — save the profile in the old admin once.',
  'cms-api.employee.invalid_avatar': () => 'The photo must be a JPEG, PNG or WebP of at most 5 MB.',
};

/**
 * @returns the Result error object, or null when the response is a success
 */
export const resultErrorOf = (response) => {
  const body = response && response.data;
  if (!body || !body.error) {
    return null;
  }

  return body.error;
};

export const resultErrorMessage = (error) => {
  if (!error) {
    return 'Unknown error';
  }

  const build = messages[error.code];
  if (build) {
    try {
      return build(error.data || {});
    } catch (e) {
      // A shape we did not expect must not swallow the refusal itself.
      return error.code;
    }
  }

  return error.code || 'Unknown error';
};

export default { resultErrorOf, resultErrorMessage };
